import { AnyAction } from 'redux';
import { DETAILS_BREADCRUMB, BREADCRUMBS, RESET_STATE } from '@app/store/constants';
import { IBreadcrumbsState } from '@app/models';

const initialBreadcrumbsState: IBreadcrumbsState = {
    details: '',
    array: []
};

export function breadcrumbs(state: IBreadcrumbsState = initialBreadcrumbsState, action: AnyAction) {
    const { payload, type } = action;

    switch (type) {
        case RESET_STATE:
            return initialBreadcrumbsState;

        case DETAILS_BREADCRUMB:
            return {
                ...state,
                details: payload
            };

        case BREADCRUMBS:
            return {
                ...state,
                array: payload
            };

        default:
            return state;
    }
}
